import PlayCircleOutlined from '@mui/icons-material/PlayCircleOutlined';
import SettingsOutlined from '@mui/icons-material/SettingsOutlined';
import TaskAlt from '@mui/icons-material/TaskAlt';
import Timeline from '@mui/icons-material/Timeline';
import { COPY } from '../copy';

export interface NavItem {
  path: '/start' | '/todo' | '/tracking' | '/preferences';
  label: string;
  Icon: typeof TaskAlt;
}

export const NAV_ITEMS: readonly NavItem[] = [
  { path: '/start', label: COPY.navStart, Icon: PlayCircleOutlined },
  { path: '/todo', label: COPY.navTodo, Icon: TaskAlt },
  { path: '/tracking', label: COPY.navTracking, Icon: Timeline },
  { path: '/preferences', label: COPY.navPreferences, Icon: SettingsOutlined },
];
